import { ReactElement, ReactNode, MouseEvent } from 'react';

export enum Actions {
	EDIT = 'edit',
	DELETE = 'delete',
	GENERATE_KEY = 'generate_key',
	SEND_TEMP_PASSWORD = 'send_temp_password',
}

export interface ActionItem<DataModel> {
	type: Actions;
	callback: (item: DataModel) => void;
	permitted?: (item: DataModel) => boolean;
}

export interface TableProps<DataModel> {
	ariaLabel: string;
	data: Array<DataModel>;
	columns: Array<Column<DataModel>>;
	actionsColumn?: ActionsColumn<DataModel>;
	empty: ReactNode;
	rowAction?: (item: DataModel) => void;
}

export interface Column<DataModel> {
	name: string;
	align?: 'center' | 'left' | 'right' | 'inherit' | 'justify';
	accessors: Array<keyof DataModel>;
	render?: (props: Partial<DataModel>) => ReactNode;
	minWidth?: number;
}

export interface ActionsColumn<DataModel> {
	name: string;
	render?: (item: DataModel) => ReactElement;
	actions?: Array<ActionItem<DataModel>>;
}

export interface TablePagination {
	total: number;
	currentPage: number;
	perPage: number;
	onPageChange: (event: MouseEvent<HTMLButtonElement> | null, page: number) => void;
}
